import styled from 'styled-components';
import {motion} from 'framer-motion';
import {dFlexCenter} from '../../../../globalVariables/GlobalFlex';

export const closeBtn = styled(motion.button)`
    ${dFlexCenter}
    position: fixed;
    left: 50%;
    bottom: 10%;
    width: 56px;
    height: 56px;
    border: 1px solid var(--color-bg-surface-inverse-hover);
    border-radius: var(--border-radius-border-radius-full);
    background: rgba(28, 28, 30, 0.55);
    color: var(--color-icon-inverse);
    cursor: pointer;
    -webkit-backdrop-filter: blur(14px) saturate(1.4);
    backdrop-filter: blur(14px) saturate(1.4);
`;
